import {
  Outlet,
  createFileRoute,
  useRouterState,
} from "@tanstack/react-router";

import { Footer } from "~/components/ui/footer";
import { Header } from "~/components/ui/header";
import { READINESS_PUBLIC_PATH } from "~/lib/shared/readiness/routes";

export const Route = createFileRoute("/_public")({
  component: PublicLayout,
});

function PublicLayout() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const isDiagnostic = pathname === READINESS_PUBLIC_PATH;

  return (
    <div className="flex min-h-dvh flex-col justify-between">
      <Header variant={isDiagnostic ? "diagnostic" : "default"} />
      <div className="z-10 grow">
        <Outlet />
      </div>
      <Footer variant={isDiagnostic ? "diagnostic" : "default"} />
    </div>
  );
}
